function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { HUBSPOT_API_FIRSTNAME, HUBSPOT_API_LASTNAME, HUBSPOT_API_EMAIL, HUBSPOT_API_JOB, HUBSPOT_API_PHONE, HUBSPOT_API_COMPANY, HUBSPOT_API_COMPANY_SIZE, HUBSPOT_API_HOW_CAN_HELP, HUBSPOT_API_PRODUCT_QUESTION, HUBSPOT_API_USE_CASE_FORM_SELECTION, productQuestionOptionsList, whatToAchieveOptionsList } from "./hubspot-constants";
import { getUrlParamValueFromCurrentLocation } from "utils/url";
import { inputTypes, MAXIMUM_LONG_INPUT_LENGTH, FIRSTNAME_INPUT, LASTNAME_INPUT, PHONE_INPUT, EMAIL_INPUT } from "client/services/form-service/form-inputs";
import { SMALLEST_COMPANY_SIZE, companySizeValuesList } from "client/services/form-service/form-constants";
import { FORM_FIELD_LABELS, HUBSPOT_FIELD_LABELS, FORM_ERROR_MESSAGES, FORM_PLACEHOLDERS } from "client/services/form-service/form-translation-keys";
const validateHowCanWeHelpFieldRequiredByCompanySize = (currentValue, allInputsValues)=>{
    var _allInputsValues_HUBSPOT_API_COMPANY_SIZE;
    const companySize = (_allInputsValues_HUBSPOT_API_COMPANY_SIZE = allInputsValues[HUBSPOT_API_COMPANY_SIZE]) === null || _allInputsValues_HUBSPOT_API_COMPANY_SIZE === void 0 ? void 0 : _allInputsValues_HUBSPOT_API_COMPANY_SIZE.value;
    if (companySize === SMALLEST_COMPANY_SIZE) {
        return !!currentValue; //this can't be empty because CS need this value
    }
    return true;
};
const getEmail = ()=>{
    const emailParam = getUrlParamValueFromCurrentLocation("email");
    const emailString = emailParam.replace("%40", "@").replace(" ", "+");
    return emailString;
};
export const HUBSPOT_FIRSTNAME_INPUT = _object_spread_props(_object_spread({}, FIRSTNAME_INPUT), {
    inputName: HUBSPOT_API_FIRSTNAME,
    isRequired: true
});
export const HUBSPOT_FIRSTNAME_INPUT_WITH_PLACEHOLDER = _object_spread_props(_object_spread({}, FIRSTNAME_INPUT), {
    inputName: HUBSPOT_API_FIRSTNAME,
    isRequired: true,
    placeholder: FORM_FIELD_LABELS.REQUIRED_FIRST_NAME
});
export const HUBSPOT_LASTNAME_INPUT = _object_spread_props(_object_spread({}, LASTNAME_INPUT), {
    inputName: HUBSPOT_API_LASTNAME,
    isRequired: true
});
export const HUBSPOT_LASTNAME_INPUT_WITH_PLACEHOLDER = _object_spread_props(_object_spread({}, LASTNAME_INPUT), {
    inputName: HUBSPOT_API_LASTNAME,
    isRequired: true,
    placeholder: FORM_FIELD_LABELS.REQUIRED_LAST_NAME
});
export const HUBSPOT_EMAIL_INPUT = _object_spread_props(_object_spread({}, EMAIL_INPUT), {
    inputName: HUBSPOT_API_EMAIL,
    defaultValue: getEmail(),
    isRequired: true
});
export const HUBSPOT_EMAIL_INPUT_WITH_PLACEHOLDER = _object_spread_props(_object_spread({}, EMAIL_INPUT), {
    inputName: HUBSPOT_API_EMAIL,
    defaultValue: getEmail(),
    isRequired: true,
    placeholder: FORM_FIELD_LABELS.REQUIRED_WORK_EMAIL
});
export const HUBSPOT_JOBTITLE_INPUT = {
    id: "job_title",
    inputName: HUBSPOT_API_JOB,
    type: inputTypes.TEXT,
    isRequired: false,
    title: HUBSPOT_FIELD_LABELS.JOB_TITLE,
    validate: (val)=>!val || val.length < MAXIMUM_LONG_INPUT_LENGTH,
    errorMessage: FORM_ERROR_MESSAGES.JOB_TITLE
};
export const HUBSPOT_JOBTITLE_INPUT_WITH_PLACEHOLDER = {
    id: "job_title",
    inputName: HUBSPOT_API_JOB,
    type: inputTypes.TEXT,
    isRequired: false,
    title: HUBSPOT_FIELD_LABELS.JOB_TITLE,
    validate: (val)=>!val || val.length < MAXIMUM_LONG_INPUT_LENGTH,
    errorMessage: FORM_ERROR_MESSAGES.JOB_TITLE,
    placeholder: HUBSPOT_FIELD_LABELS.JOB_TITLE
};
export const HUBSPOT_PHONE_INPUT = _object_spread_props(_object_spread({}, PHONE_INPUT), {
    inputName: HUBSPOT_API_PHONE,
    isRequired: true,
    placeholder: FORM_FIELD_LABELS.REQUIRED_PHONE_NUMBER
});
export const HUBSPOT_COMPANY_INPUT_WITH_PLACEHOLDER = {
    id: "company_name",
    inputName: HUBSPOT_API_COMPANY,
    type: inputTypes.TEXT,
    isRequired: true,
    placeholder: HUBSPOT_FIELD_LABELS.REQUIRED_COMPANY_NAME
};
export const HUBSPOT_COMPANY_INPUT = {
    id: "company_name",
    inputName: HUBSPOT_API_COMPANY,
    type: inputTypes.TEXT,
    isRequired: true,
    title: HUBSPOT_FIELD_LABELS.COMPANY_NAME
};
export const HUBSPOT_COMPANYSIZE_INPUT_WITH_PLACEHOLDER = {
    id: "company_size",
    inputName: HUBSPOT_API_COMPANY_SIZE,
    type: inputTypes.MULTI_SELECT,
    isMulti: false,
    options: companySizeValuesList,
    placeholder: FORM_FIELD_LABELS.REQUIRED_COMPANY_SIZE,
    isRequired: true,
    closeMenuOnSelect: true
};
export const HUBSPOT_COMPANYSIZE_INPUT = {
    id: "company_size",
    inputName: HUBSPOT_API_COMPANY_SIZE,
    type: inputTypes.MULTI_SELECT,
    isMulti: false,
    options: companySizeValuesList,
    title: FORM_FIELD_LABELS.COMPANY_SIZE,
    isRequired: true,
    closeMenuOnSelect: true
};
// With `useTitleAsLabel` (the floating-label V2 form, which renders no separate title) the field shows its title in both
// the resting and floating state, matching the HubSpot form's "How can our team help you?"
export const getHubspotHowCanHelpInput = (overrideParams = {}, useTitleAsLabel = false)=>{
    const title = (overrideParams === null || overrideParams === void 0 ? void 0 : overrideParams.titleKey) || HUBSPOT_FIELD_LABELS.HOW_CAN_HELP_TITLE;
    return {
        id: "how_can_help",
        inputName: HUBSPOT_API_HOW_CAN_HELP,
        type: inputTypes.TEXT_AREA,
        isRequired: false,
        placeholder: useTitleAsLabel ? title : (overrideParams === null || overrideParams === void 0 ? void 0 : overrideParams.placeholderKey) || HUBSPOT_FIELD_LABELS.HOW_CAN_HELP_PLACEHOLDER,
        floatingLabel: useTitleAsLabel ? title : HUBSPOT_FIELD_LABELS.HOW_CAN_HELP_FLOATING_LABEL,
        title,
        validateOnFormSubmission: validateHowCanWeHelpFieldRequiredByCompanySize,
        errorMessage: FORM_ERROR_MESSAGES.DETAILS_FIELD_REQUIRED
    };
};
export const HUBSPOT_HOWPLANUSE_INPUT = {
    id: "how_plan_use",
    inputName: HUBSPOT_API_HOW_CAN_HELP,
    type: inputTypes.TEXT_AREA,
    isRequired: false,
    placeholder: HUBSPOT_FIELD_LABELS.HOW_CAN_HELP_PLACEHOLDER,
    floatingLabel: HUBSPOT_FIELD_LABELS.HOW_CAN_HELP_FLOATING_LABEL,
    title: HUBSPOT_FIELD_LABELS.HOW_PLAN_TO_USE_TITLE,
    validateOnFormSubmission: validateHowCanWeHelpFieldRequiredByCompanySize,
    errorMessage: FORM_ERROR_MESSAGES.DETAILS_FIELD_REQUIRED
};
export const HUBSPOT_PRODUCT_QUESTION_INPUT = {
    id: "product_question",
    inputName: HUBSPOT_API_PRODUCT_QUESTION,
    type: inputTypes.MULTI_SELECT,
    isMulti: true,
    title: HUBSPOT_FIELD_LABELS.PRODUCT_QUESTION,
    options: productQuestionOptionsList,
    placeholder: FORM_PLACEHOLDERS.SELECT,
    isRequired: true,
    errorMessage: FORM_ERROR_MESSAGES.SELECT_AT_LEAST_ONE
};
export const HUBSPOT_PRODUCT_QUESTION_INPUT_WITH_PLACEHOLDER = {
    id: "product_question",
    inputName: HUBSPOT_API_PRODUCT_QUESTION,
    type: inputTypes.MULTI_SELECT,
    isMulti: true,
    options: productQuestionOptionsList,
    placeholder: HUBSPOT_FIELD_LABELS.SHORTER_REQUIRED_PRODUCT_AI_QUESTION,
    isRequired: true,
    errorMessage: FORM_ERROR_MESSAGES.SELECT_AT_LEAST_ONE
};
// base_form_what_to_achieve_test — shown under the product question
export const HUBSPOT_WHAT_TO_ACHIEVE_INPUT = {
    id: "what_to_achieve",
    inputName: HUBSPOT_API_USE_CASE_FORM_SELECTION,
    type: inputTypes.MULTI_SELECT,
    isMulti: true,
    options: whatToAchieveOptionsList,
    title: HUBSPOT_FIELD_LABELS.WHAT_TO_ACHIEVE,
    placeholder: HUBSPOT_FIELD_LABELS.WHAT_TO_ACHIEVE,
    menuHeader: HUBSPOT_FIELD_LABELS.WHAT_TO_ACHIEVE_MENU_HEADER,
    isRequired: true,
    errorMessage: FORM_ERROR_MESSAGES.SELECT_AT_LEAST_ONE
};
// Same wording as the HubSpot form's own product question
export const HUBSPOT_PRODUCT_QUESTION_INPUT_WITH_HUBSPOT_LABEL = _object_spread_props(_object_spread({}, HUBSPOT_PRODUCT_QUESTION_INPUT_WITH_PLACEHOLDER), {
    placeholder: HUBSPOT_FIELD_LABELS.PRODUCT_QUESTION
});
